var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"6"}},[_c('timeline-basic')],1),_c('b-col',{attrs:{"cols":"12","md":"6"}},[_c('timeline-with-icon')],1),_c('b-col',{attrs:{"cols":"12","md":"6"}},[_c('timeline-custom-content')],1),_c('b-col',{attrs:{"cols":"12","md":"6"}},[_c('timeline-custom-content-with-icon')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }